import { getActiveDesignFirmId } from "ui";
import { accessUserFromPermissions } from "ui/utils/usePermissions";
import { sharingV2Doc } from "ui/utils/workspace/sharingV2";
import type { Permissions } from "ts-interfaces";
import { filingProject } from "./accessApi";

// The team of a project whose team has sharing v2 and the user belongs to,
// else null. The project may be outside the active workspace. Callers without
// permissions at hand get the login state's cached copy.
export async function flaggedProjectFirm(
  projectId: string | null | undefined,
  uid: string,
  permissions?: Permissions | null,
) {
  const project = await filingProject(projectId);
  if (!sharingV2Doc(project)) return null;
  const firm = project!.design_firm_id as string;
  const perms =
    permissions !== undefined
      ? permissions
      : await import("../../studioxr/auth/LoginState")
          .then((m) => m.useLoginState.getState().getPermmissions())
          .catch(() => null);
  return accessUserFromPermissions(uid, perms).teams.includes(firm) ? firm : null;
}

// The workspace a new item created inside a project is stamped with. Under
// Teams sharing it is the project's team (the backend refuses cross-workspace
// filing); otherwise the active workspace, as before.
export const createFirmFor = async (
  uid: string,
  projectId: string | null | undefined,
  permissions?: Permissions | null,
) => (await flaggedProjectFirm(projectId, uid, permissions)) ?? getActiveDesignFirmId(uid);
